import { useState, useEffect, useCallback } from 'react';
import logger from '../../utils/logger';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdminFeedback = () => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('all');

  const fetchFeedback = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const q = statusFilter !== 'all' ? `?status=${statusFilter}` : '';
      const res = await fetch(`${API_URL}/api/admin/feedback${q}`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setFeedback(data.feedback || []);
      }
    } catch (err) { logger.error('Failed to fetch feedback:', err); }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter]);

  useEffect(() => { fetchFeedback(); }, [fetchFeedback]);

  const updateStatus = async (feedbackId, newStatus) => {
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${API_URL}/api/admin/feedback/${feedbackId}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ status: newStatus }),
    });
    if (res.ok) fetchFeedback();
  };

  return { feedback, loading, statusFilter, setStatusFilter, updateStatus };
};
